// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fpKiD","label":"styles_label__2UGVz"};